<template>
  <!-- <el-dialog
    title="导入菜品"
    :visible.sync="show"
    width="400px"
    center
  > -->
  <el-dialog :visible.sync="show" width="700px" :show-close="false" :close-on-click-modal="false" @close="fCancel">
    <div class="x-sm-pop-head x-bd-bottom" style="background-color: #FFF;">
      <div class="x-flex">
        <div class='x-flex x-h50 x-m-r-20'>{{ fLng('导入菜品', 'dish') }}</div>
      </div>
      <div class="x-flex ">
        <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;" @click="fCancel"></i>
      </div>
    </div>
    <div class="import-dialog-content x-sm-card">
      <div class="x-sm-card-title">文件路径</div>
      <div class="file-select-section">
        <span class="file-label">请选择导入文件(.xls):</span>
        <div class="file-input-wrapper" @click="fShowSelect">
          <el-input type="text" size="small" :value="selectedFileName || ''" readonly>
            <i class="el-icon-more more-icon x-cur-poi x-lh-32 x-m-r-10" slot="suffix"></i>
          </el-input>
          <input type="file" ref="fileInput" style="display: none" @change="fHandleFileChange" accept=".xls" />
        </div>
        <!-- <x-button margin_left='10px' :title="'下载模板'" @click.native='fDownLoadTmp' >
        </x-button> -->
        <div class="c-cz x-cur-poi x-m-l-10" @click='fDownLoadTmp'>下载模板</div>
      </div>
      <!-- 上传状态显示 -->
      <div v-if="uploadStatus === 'uploading'" class="upload-status uploading">
        上传中...
      </div>
      <div v-else-if="uploadStatus === 'success'" class="upload-status success">
        上传成功
      </div>
      <div v-else-if="uploadStatus === 'error'" class="upload-status error">
        上传失败，请重试
      </div>
    </div>

    <div class=" x-sm-pop-foot bgc-f x-bd-top x-p-20" style="text-align: right;">
      <!-- 下载导入模板按钮 -->
      <div v-if="req_id">
        <x-button :title="'导出导入的异常数据'" @click.native='fDownload' bgc='#fff' color='#242424' border='1px solid #E6E8EB'>
        </x-button>
      </div>
      <!-- 导入按钮 -->
      <x-button margin_left='10px' :title="'导入'" @click.native="fImport" :disabled="!selectedFile"></x-button>
      <!-- 取消按钮 -->
      <x-button margin_left='10px' :title="'取消'" @click.native='fCancel' bgc='#fff' color='#242424'
        border='1px solid #E6E8EB'>
      </x-button>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="fCancel">取消</el-button>
      <el-button type="primary" @click="fImport" :disabled="!selectedFile">确定</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
export default {
  name: 'ImportExcel',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFile: null,
      selectedFileName: '',
      req_id: '',
      uploadStatus: 'idle', // idle, uploading, success, error
      uploadProgress: 0,
      fileName: ''
    }
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          // 弹窗打开时做初始化操作
          this.fResetState()
          this.req_id = ''
        }
      },
      immediate: false
    }
  },
  methods: {
    fHandleFileChange(e) {
      const file = e.target.files[0]
      console.log(file)
      if (file) {
        this.selectedFile = file
        let fileExt = file.name.substring(file.name.lastIndexOf('.'))
        if (fileExt != '.xls') {
          return this.$message('上传文件仅支持xls格式，请重新上传！');
        }
        this.selectedFileName = file.name
        // 选择文件后自动上传
        this.fUploadFile()
      }
    },
    fCancel() {
      this.$emit('close')
      this.fResetState()
    },
    fResetState() {
      this.selectedFile = null
      this.selectedFileName = ''
      this.uploadStatus = 'idle'
      this.uploadProgress = 0
      this.fileName = ''
      this.req_id = ''
      // 重置文件输入
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },
    async fUploadFile() {
      if (!this.selectedFile) {
        return this.$message.warning('请选择要导入的文件')
      }

      try {
        let fileExt = this.selectedFile.name.substring(this.selectedFile.name.lastIndexOf('.'))
        if (fileExt != '.xls') {
          return this.$message('上传文件仅支持xls格式，请重新上传！');
        }

        // 生成reqId：当前时间戳(年月日时分秒) + 5位随机数
        const now = new Date()
        const timestamp = now.getSeconds().toString().padStart(2, '0')
        const randomNum = Math.floor(100 + Math.random() * 900).toString()
        const reqId = '1234'//timestamp + randomNum

        // 获取MchId和MallId
        const mchId = this.$store.state.djsAdmin.mch_id || ''
        const mallId = this.$store.state.djsAdmin.mall_id || ''

        // 生成文件名：reqId + Pro + MchId + MallId + 文件扩展名
        this.fileName = mchId + mallId + 'Pro' + fileExt

        const formData = new FormData()
        formData.append("filePath", "djsCy");
        formData.append(this.fileName, this.selectedFile);

        // 设置上传状态
        this.uploadStatus = 'uploading'
        this.uploadProgress = 0

        // 直接使用axios发送文件上传请求
        let sReqUrl = this.$store.state.djsAdmin.load_url + '/djsAdmin/upFile'
        await this.axios({
          method: "post",
          url: sReqUrl,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }).then((res) => {
          // 上传成功
          this.uploadStatus = 'success'
          this.uploadProgress = 100
        });
      } catch (error) {
        this.uploadStatus = 'error'
        this.$message.error('上传失败，请重试')
        console.error('上传错误:', error)
      }
    },
    async fImport() {
      if (this.uploadStatus !== 'success') {
        return this.$message.warning('请先上传文件')
      }

      try {
        // 生成reqId：当前时间戳(年月日时分秒) + 5位随机数
        const now = new Date()
        const timestamp = now.getSeconds().toString().padStart(2, '0')
        const randomNum = Math.floor(100 + Math.random() * 900).toString()
        const reqId = '1234'//timestamp + randomNum

        let ojn = {
          OPER: 'PRO',
          CHG_USER_ID: this.$store.state.djsAdmin.user_id,
          MALL_ID: this.$store.state.djsAdmin.mall_id,
          EXCEL_NAME: this.fileName,
          REQ_ID: reqId,
        }

        let resExcel = await this.api.djsApi.fDjsAdminApi({
          methodName: 'EXCEL_IMPORT',
          js: ojn
        })

        // 储存req_id
        this.req_id = resExcel.req_id

        // 弹出导入结果 弹窗
        this.$confirm(resExcel.msg, '导入信息', {
          confirmButtonText: '确定',
          showCancelButton: false,
        }).then(async () => {
          // 导入完成后重置部分状态，保留req_id
          this.selectedFile = null
          this.selectedFileName = ''
          this.uploadStatus = 'idle'
          this.uploadProgress = 0
          this.fileName = ''
          // 重置文件输入
          if (this.$refs.fileInput) {
            this.$refs.fileInput.value = ''
          }
        }).catch(() => {
          // 导入完成后重置部分状态，保留req_id
          this.selectedFile = null
          this.selectedFileName = ''
          this.uploadStatus = 'idle'
          this.uploadProgress = 0
          this.fileName = ''
          // 重置文件输入
          if (this.$refs.fileInput) {
            this.$refs.fileInput.value = ''
          }
        })
      } catch (error) {
        this.$message.error('导入失败，请重试')
        console.error('导入错误:', error)
      }
    },
    async fDownload() {
      if (!this.req_id) {
        return this.$message.warning('请先导入文件')
      }
      try {
        let resExcel = await this.api.djsApi.fDjsAdminApi({
          methodName: 'EXCEL_EXPORT',
          js: {
            OPER: 'PRO',
            REQ_ID: this.req_id,
            CHG_USER_ID: this.$store.state.djsAdmin.user_id,
            MALL_ID: this.$store.state.djsAdmin.mall_id,
          }
        })
        if (resExcel.result === 'sucess') {
          this.$message.success('下载成功')
          let sReqUrl = this.$store.state.djsAdmin.load_url + '/djsAdmin/filePath/djsCy/' + resExcel.file
          window.open(sReqUrl)
        } else {
          this.$message.error(resExcel.msg)
        }
      } catch (error) {
        this.$message.error('下载失败，请重试')
        console.error('下载错误:', error)
      }
    },
    fDownloadTemplate() {
      // 下载导入模板的逻辑
      // 这里可以根据实际情况实现模板下载功能
      this.$message.info('下载导入模板功能待实现')
    },
    fShowSelect() {
      // 触发文件选择对话框
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    fDownLoadTmp() {
      // 下载导入模板的逻辑
      // 这里可以根据实际情况实现模板下载功能
      window.open('https://soft.shopzgl.com//djsFile/excelTpl/djsCy/djsCyETplPro.xls')
    }
  }
}
</script>

<style lang="less" scoped>
.import-dialog-content {
  padding: 30px;
  margin: 30px;

  .file-path-title {
    font-weight: bold;
    margin-bottom: 15px;
  }

  .file-select-section {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .file-label {
      width: 150px;
      font-size: 14px;
    }

    .file-input-wrapper {
      flex: 1;
      display: flex;
      align-items: center;

      .file-input {
        flex: 1;
        height: 32px;
      }

      .more-icon {
        cursor: pointer;
        color: #909399;
        font-size: 16px;

        &:hover {
          color: #409EFF;
        }
      }
    }
  }

  .upload-status {
    margin-top: 10px;
    font-size: 14px;

    &.uploading {
      color: #409EFF;
    }

    &.success {
      color: #67C23A;
    }

    &.error {
      color: #F56C6C;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/importExcel.vue